export const txtLandingTitle = {
  id: "Perayaan Pernikahan",
  en: "The Wedding of",
};

export const txtBrideGroomName = {
  id: "Khansa & Idan",
  en: "Khansa & Idan",
};

export const txtFrom = {
  id: "Kepada",
  en: "Dear",
};

export const txtLandingButton = {
  id: "Buka undangan",
  en: "Open invitation",
};
export const txtGuestPlaceholder = {
  id: "Nama tamu",
  en: "Guest name",
};
